export function joinRoutePath(parentPath, childPath) {
  if (!childPath) {
    return parentPath || '/'
  }
  if (childPath.startsWith('/')) {
    return childPath
  }
  const parent = !parentPath || parentPath === '/' ? '' : parentPath
  return `${parent}/${childPath}`.replace(/\/+/g, '/')
}

export function getFirstAccessibleRoute(routes, parentPath = '') {
  for (let i = 0; i < routes.length; i++) {
    const route = routes[i]
    if (route.hidden) {
      continue
    }
    const fullPath = joinRoutePath(parentPath, route.path)
    if (route.children && route.children.length > 0) {
      const child = getFirstAccessibleRoute(route.children, fullPath)
      if (child) {
        return child
      }
    }
    if (route.path && route.path !== '*' && route.redirect !== 'noredirect') {
      return { path: route.redirect && route.redirect !== 'noredirect' ? route.redirect : fullPath }
    }
  }
  return { path: '/profile' }
}

export function routePathExists(routes, path, parentPath = '') {
  for (let i = 0; i < routes.length; i++) {
    const route = routes[i]
    const fullPath = joinRoutePath(parentPath, route.path)
    if (fullPath === path || route.redirect === path) {
      return true
    }
    if (route.children && route.children.length > 0 && routePathExists(route.children, path, fullPath)) {
      return true
    }
  }
  return false
}



// WEBPACK FOOTER //
// ./src/utils/route.js